import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Language } from './language.types';

export interface LanguageProvider {
    getLanguage(): Observable<Language | undefined> | Language | undefined;
}

export const LANGUAGE_PROVIDER = new InjectionToken<LanguageProvider>('languageProviderConfig');
export const DEFAULT_ENGLISH_LANGUAGE_SUPPORT_PROVIDER = new InjectionToken<boolean>('DefaultEnglishLanguageSupport');
